import { render, staticRenderFns } from "./indexFooter.vue?vue&type=template&id=3edd1f58&scoped=true&"
import script from "./indexFooter.vue?vue&type=script&lang=js&"
export * from "./indexFooter.vue?vue&type=script&lang=js&"
import style0 from "./indexFooter.vue?vue&type=style&index=0&id=3edd1f58&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3edd1f58",
  null
  
)

export default component.exports